import { render, staticRenderFns } from "./BtnManutCadPro.vue?vue&type=template&id=0b036c56&"
import script from "./BtnManutCadPro.vue?vue&type=script&lang=js&"
export * from "./BtnManutCadPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports